<template>
    <div class="pt-5">
        <flickity class="carousel" ref="flickity" :options="flickityOptions">
            <div style="width: 100%">
                <img src="@/assets/images/hero-3.jpg" width="100%" class="mx-auto d-block" alt="Home Solution Architecture" />
            </div>
            <div style="width: 100%">
                <img src="@/assets/images/hero-1.jpg" width="100%" class="mx-auto d-block" alt="Home Solution Architecture" />
            </div>
            <div style="width: 100%">
                <img src="@/assets/images/hero-2.jpg" width="100%" class="mx-auto d-block" alt="Home Solution Architecture" />
            </div>
        </flickity>
    </div>
</template>

<script type="text/javascript">
import Flickity from "vue-flickity";

export default {
	name: "hero",
	data() {
		return {
			flickityOptions: {
				prevNextButtons: true,
				pageDots: false,
				wrapAround: true,
				autoPlay: true,
			}
		};
	},
	components: {
		Flickity
	},
	methods: {
		next() {
			this.$refs.flickity.next();
		},

		previous() {
			this.$refs.flickity.previous();
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/home/Hero.vue